import React from 'react';
import { ShieldCheckIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black border-t border-zinc-900" data-id="element-159">
      <div className="max-w-7xl mx-auto" data-id="element-160">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-zinc-900" data-id="element-161">
          <a href="/application" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-white rounded-lg hover:bg-zinc-100 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-162">
            Get Started Now
          </a>
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-163">
          {/* Column 1: Company */}
          <div data-id="element-164">
            <h3 className="text-1xl font-bold mb-6 text-white tracking-tight" data-id="element-165">
              VANTAGE CAPITAL GROUP
            </h3>
            <p className="text-white mb-6 text-sm leading-relaxed max-w-xs" data-id="element-166">
              Empowering businesses with flexible capital solutions.
            </p>
            <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-167">
              <ShieldCheckIcon className="w-5 h-5 text-white" data-id="element-168" />
              <span data-id="element-169">Secure & Confidential</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-170">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-171">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-172">
              <li data-id="element-173">
                <a href="#" className="hover:text-white transition-colors" data-id="element-174">
                  Home
                </a>
              </li>
              <li data-id="element-175">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-176">
                  About Us
                </a>
              </li>
              <li data-id="element-177">
                <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-178">
                  How It Works
                </a>
              </li>
              <li data-id="element-179">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-180">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Funding Types */}
          <div data-id="element-181">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-182">
              Funding Options
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-183">
              <li data-id="element-184">
                <a href="#" className="hover:text-white transition-colors" data-id="element-185">
                  SBA Loans
                </a>
              </li>
              <li data-id="element-186">
                <a href="#" className="hover:text-white transition-colors" data-id="element-187">
                  Business Lines of Credit
                </a>
              </li>
              <li data-id="element-188">
                <a href="#" className="hover:text-white transition-colors" data-id="element-189">
                  Equipment Financing
                </a>
              </li>
              <li data-id="element-190">
                <a href="#" className="hover:text-white transition-colors" data-id="element-191">
                  Working Capital
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-white transition-colors" data-id="element-193">
                  Merchant Cash Advance
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div data-id="element-194">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-195">Contact Us</h4>
            <ul className="space-y-4 text-sm" data-id="element-196">
              <li data-id="element-197">
                <a href="mailto:info@vantagecapitalgroup.net" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-198">
                  <MailIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-199" />
                  info@vcgcapitalpartners.com
                </a>
              </li>
              <li data-id="element-200">
                <a href="tel:929-816-6805" className="flex items-start gap-3 text-zinc-400 hover:text-white transition-colors" data-id="element-201">
                  <PhoneIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-202" />
                  (929) 816-6805
                </a>
              </li>
              <li data-id="element-203">
                <div className="flex items-start gap-3 text-zinc-400" data-id="element-204">
                  <MapPinIcon className="w-4 h-4 text-white mt-0.5 shrink-0" data-id="element-205" />
                  <span data-id="element-206">
                    1221 Brickell Ave STE 900
                    <br data-id="element-207" />
                    Miami, FL 33131
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col justify-center items-center text-xs text-white space-y-2" data-id="element-208">
          <p data-id="element-209">© {currentYear} Vantage Capital Group. All rights reserved.</p>
          <div className="flex space-x-8" data-id="element-210">
            <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-211">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-212">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}